var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z",
    fill: "#C198ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9863 24.2176L26.2687 12.3786C26.3893 12.1486 26.74 12.0391 26.9776 12.2314C27.2152 12.4236 27.3171 12.7026 27.1248 12.9402L15.8424 24.7792C15.7218 25.0092 15.3712 25.1186 15.1336 24.9264C14.896 24.7342 14.8657 24.4476 14.9863 24.2176Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 4.0021
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0533 24.8624L9.95028 19.7508C9.71268 19.5586 9.74652 19.1928 9.94632 19.0268C10.1461 18.8609 10.5043 18.8231 10.6703 19.0229L15.7733 24.1345C16.0109 24.3268 15.9771 24.6925 15.7773 24.8585C15.585 25.0961 15.2193 25.0622 15.0533 24.8624Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 4.0021
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPrimary);
export default __webpack_public_path__ + "static/media/success-primary.f2770d5bf55cb08ad815f247139aba90.svg";
export { ForwardRef as ReactComponent };